import { mixins } from '4all-ui/styles';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  .grid-sizer {
    min-width: 340px;
    @media (min-width: 1200px) {
      :nth-child(3n) {
        margin-right: 0px;
      }
    }

    @media (max-width: 1170px) {
      :nth-child(2n) {
        margin-right: 0px;
      }
      width: 47.4%;
    }

    @media (min-width: 1171px) {
      max-width: 340px;
    }
  }
`;

export const LoaderContainer = styled.div`
  ${mixins.flexPosition({ justify: 'center' })}
  ${({ customStyles }) => customStyles}
`;



// WEBPACK FOOTER //
// ./src/styles/StyledComponents/GenericList.js